import * as React from "react";

import "./ncoa-failed.scss";

import {cs}       from "@Common/react/chain-services";
import {Checkbox} from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";

export const NcoaFailed = ({state, count}) => cs(
    () => (
        <div className="ncoa-failed-1z6">
            <div className="box" {...{onClick: () => state.change(v=>!v)}}>
                {Checkbox({
                    checked: state.value,
                    xdQaName: "Include failed addresses",
                })}
                <div className="text">
                    <div className="title" xd-qa-type="label" xd-qa-name="Include failed addresses label">
                        Include failed addresses
                    </div>
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Include failed addresses description">
                        <div className="line">
                            Address quantity excludes {count ?? "--"} addresses because they failed USPS certification.
                        </div>
                        <div className="line">
                            Check this option to include them.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ),
);
